import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import perform from 'ember-concurrency/helpers/perform';
import type ForcJournalEventBasedComponent from '../abstract/journal-event-based-component';
import CancelButton from './cancel-button';
import SubmitButton from './submit-button';
import { hash } from '@ember/helper';
import type { WithBoundArgs as WBA } from '@glint/template';
interface S {
    Element: HTMLDivElement;
    Args: {
        forcComponent?: ForcJournalEventBasedComponent;
        smallFooter?: boolean;
    };
    Blocks: {
        default: [{
                CancelButton: WBA<typeof CancelButton, 'disabled' | 'onClick' | 'title'>;
                SubmitButton: WBA<typeof SubmitButton, 'disabled' | 'isLoading' | 'title' | 'isReadOnly'>;
            }];
    };
}
export default class ForcProviderFooterComponent extends Component<S> {
    get isSubmitButtonDisabled() {
        return (this.args.forcComponent?.onSubmit.isRunning || (this.args.forcComponent?.checkDirtyness && !this.args.forcComponent.isDirty));
    }
    static{
        template(`
    {{! prettier-ignore }}
    <div
      class='no-print
        {{unless @smallFooter "mt-[4em]"}}
        -mr-1 mb-0 flex justify-between'
      ...attributes
    >
      {{! @glint-expect-error We have 2 errors here. The first is on CancelButton because of the "onClick" argument and the perform helper. The second is because of a typo on "isReadonly". It should be "isReadOnly". The "isReadonly" typo makes the arg useless on SubmitButton and this arg should be removed}}
      {{yield (hash CancelButton=(component CancelButton disabled=@forcComponent.onSubmit.isRunning onClick=(perform @forcComponent.onCancel) title=@forcComponent.cancelButtonTitle ) SubmitButton=(component SubmitButton disabled=this.isSubmitButtonDisabled isLoading=@forcComponent.onSubmit.isRunning title=@forcComponent.submitButtonTitle isReadOnly=@forcComponent.isReadonly ) ) }}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
